import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core'
import { CardDetail } from '@core/interfaces'
import { CommonModule } from '@angular/common'
import { ButtonComponent } from '@shared/components/button/button.component'
import { Room, joinRoom } from 'trystero'
import { AccountService, WebSocketService } from '@core/services'
import { environment } from '@env/environment'
import { FormsModule } from '@angular/forms'
import { DeckCardDto } from '@core/dtos'
import { ModeEnum } from '@core/enums'
import { GameHttp } from '@core/https'
import { TimerComponent } from '../timer/timer.component'

@Component({
  selector: 'app-dealer',
  standalone: true,
  imports: [CommonModule, ButtonComponent, FormsModule, TimerComponent],
  templateUrl: './dealer.component.html',
  styleUrl: './dealer.component.sass',
  providers: [WebSocketService],
})
export class DealerComponent implements AfterViewInit {
  private readonly dealerId: string = this._accountService.currentUserId
  displayedCards: CardDetail[]
  cards: CardDetail[]

  showConfirmationPanel: boolean = false
  currentSeatNo: number
  mode: ModeEnum
  countdown: number

  get modeDescription(): string {
    switch (this.mode) {
      case ModeEnum.Setup:
        return 'SETUP'
      case ModeEnum.BuyInOpen:
        return 'BUY IN OPEN'
      case ModeEnum.PlayerCards:
        return 'SELECTING PLAYER CARDS'
      case ModeEnum.MaverickCard:
        return 'SELECTING MAVERICK CARD'
      case ModeEnum.Result:
        return 'RESULT'
      case ModeEnum.PlayerBets:
        return 'PLAYER BETTING'
      case ModeEnum.Paused:
        return 'GAME PAUSED'
      default:
        return ''
    }
  }

  @ViewChild('dealerVideo') dealerVideo: ElementRef
  private dealerStream: MediaStream

  mediaConstraints = {
    audio: true,
    video: {
      width: 2020,
      height: 2040,
    },
  }
  room: Room

  constructor(
    private _webSocketService: WebSocketService,
    private _gameHttp: GameHttp,
    private _accountService: AccountService,
  ) {}

  ngOnInit(): void {
    this._gameHttp.getCurrentConfig(this.dealerId).subscribe((i) => {
      this.mode = i?.mode || ModeEnum.Setup
      if (!i) {
        return
      }
    })
    this.listenToSocket()
  }

  async ngAfterViewInit(): Promise<void> {
    await this.startLocalVideo()

    this.startStreaming()
  }

  // confirmCards(isConfirm: boolean) {
  //   if (this.mode === ModeEnum.PlayerCards) {
  //     this._webSocketService.emitPlayerCardsConfirmation({
  //       isConfirm,
  //       dealerId: this.dealerId,
  //       cards: this.cards,
  //     })
  //   } else if (this.mode === ModeEnum.MaverickCard) {
  //     this._webSocketService.emitMaverickCardConfirmation({
  //       isConfirm,
  //       dealerId: this.dealerId,
  //       seatNo: this.currentSeatNo,
  //       cards: this.cards,
  //     })
  //   }

  //   this.showConfirmationPanel = false
  // }

  listenToSocket() {
    this._webSocketService.listenToCountdown(this.dealerId, (timeRemaining: number) => {
      this.countdown = timeRemaining
    })

    this._webSocketService.listenToMode(this.dealerId, ({ mode }) => {
      this.mode = mode
    })
  }

  async startLocalVideo(): Promise<void> {
    this.dealerStream = await navigator.mediaDevices.getUserMedia(this.mediaConstraints)
    this.dealerStream.getTracks().forEach((track) => {
      track.enabled = true
    })

    this.dealerVideo.nativeElement.srcObject = this.dealerStream
  }

  startStreaming() {
    const config = { appId: environment.webRtc.appId }

    this.room = joinRoom(config, this.dealerId)

    this.room.onPeerJoin((peerId) => {
      this.room.addStream(this.dealerStream, peerId)
    })

    this.room.addStream(this.dealerStream)
    this.room.onPeerLeave((peerId) => console.log('leave', peerId))
  }

  setDealerById() {
    // this.listenToSocket()
    this.room.leave()
    this.startStreaming()
    this._gameHttp.getCurrentConfig(this.dealerId).subscribe((i) => {
      this.mode = i.mode
      if (i.firstCard && i.secondCard) {
        this.cards = [i.firstCard, i.secondCard]
      } else {
        this.cards = []
      }
    })
  }
}
